import React from 'react';

const SvgAddPrimary = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.875 11.125V5.875C12.875 5.39175 12.4832 5 12 5C11.5168 5 11.125 5.39175 11.125 5.875V11.125H5.875C5.39175 11.125 5 11.5168 5 12C5 12.4832 5.39175 12.875 5.875 12.875H11.125V18.125C11.125 18.6082 11.5168 19 12 19C12.4832 19 12.875 18.6082 12.875 18.125V12.875H18.125C18.6082 12.875 19 12.4832 19 12C19 11.5168 18.6082 11.125 18.125 11.125H12.875Z"
        fill="#0081FF"
      />
    </svg>
  );
};

export default SvgAddPrimary;
